import React from 'react';

function Volume(props) {

    const {
        isFullScreen,
        volume,
        setVolumeValue,
        handleCloseFullScreenPlayer,
        handleOpenFullScreenPlayerDesktop,
        isMobile
    } = props

    return (
        <div className={`
                hidden basis-1/4 md:flex justify-around items-center space-x-2 space-x-reverse 
                ${(isFullScreen && isMobile) && '!flex !basis-auto w-full'} 
                ${isFullScreen && 'w-full'}                
            `}>
            <input
                type="range"
                dir='ltr'
                style={{backgroundSize: `${volume * 100}% 100%`}}
                className={`${isFullScreen && '!w-full'} w-1/2`}
                min={0}
                max={1}
                step={0.01}
                value={volume}
                onChange={(e) => setVolumeValue(parseFloat(e.target.value))}
            />
            {
                isFullScreen
                    ? <button
                        onClick={handleCloseFullScreenPlayer}
                        className='absolute top-[6%] left-[5%]'
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                             stroke="currentColor" className="w-10 h-10">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                    : <button onClick={handleOpenFullScreenPlayerDesktop}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                             stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"/>
                        </svg>

                    </button>
            }
            {/*{isFullScreen && (
                <div className="full-screen-player">
                    <button onClick={handleCloseFullScreenPlayer}>Close Full Screen</button>
                     ...
                </div>
            )}*/}
        </div>
    );
}

export default Volume;